// services/emails.ts
import { AuthFetchForm } from "../hooks/useApi";
import { SendEmailResult } from "../types/emailAccount.types";

export const emailService = {

  send: (
    apiFetchForm: AuthFetchForm,
    doctorEmail: string,
    hospitalIds: number[],
    companyIds: number[],
    files: File[],
    subject: string,
    body: string,
  ): Promise<SendEmailResult> => {
    const formData = new FormData();
    formData.append("doctor_email", doctorEmail);
    hospitalIds.forEach((id) => formData.append("hospital_ids", String(id)));
    // NOTE: o backend de /emails/enviar ainda não resolve company_ids em
    // e-mails de empresa — este campo é enviado desde já, mas o envio real
    // para empresas depende de uma mudança correspondente no backend.
    companyIds.forEach((id) => formData.append("company_ids", String(id)));
    files.forEach((file) => formData.append("arquivos", file));
    formData.append("subject", subject);
    formData.append("body", body);

    return apiFetchForm<SendEmailResult>("/emails/enviar", formData);
  },
};
